import { actionTypes } from '../constants';

export const stepChanged = (step) => ({
  type: actionTypes.createStepChanged,
  payload: step,
});

export const stateReset = () => ({ type: actionTypes.createReset });
